module.exports = __webpack_public_path__ + "static/sport/out4.496871a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/newldp/out4.png
// module id = suiJ
// module chunks = 0